import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import LogoImg from "../assets/img/logo-main.png";

export default function Contact() {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container">
          <InnerWrapper
            className="flexSpaceCenter"
            style={{ padding: "30px 0" }}
          >
            <div>
              <div>
                <Link
                  className="flexCenter animate pointer"
                  to="home"
                  smooth={true}
                  offset={-80}
                >
                  <div className="whiteBg logo-container-service">
                    <img alt="logo" style={{ width: "30px" }} src={LogoImg} />
                  </div>

                  <h1
                    className="font15 extraBold whiteColor"
                    style={{ marginLeft: "15px" }}
                  >
                    Hentian Komuniti
                  </h1>
                </Link>
              </div>

              <div style={{ marginLeft: "45px" }}>
                <p className="font15 whiteColor">
                  <i class="bi bi-envelope " style={{ marginRight: "8px" }}></i>
                  Contact us
                </p>
                <p className="small whiteColor">
                  <a
                    href="mailto:dev.hk2024@gmail.com"
                    style={{ color: "white" }}
                  >
                    dev.hk2024@gmail.com
                  </a>
                </p>
              </div>
            </div>

            <StyleP className="whiteColor font13">
              © {getCurrentYear()} -{" "}
              <span className="purpleColor font13 whiteColor">
                Hentian Komuniti.
              </span>{" "}
              All Right Reserved
            </StyleP>

            <Link
              className="whiteColor animate pointer font13"
              to="home"
              smooth={true}
              offset={-80}
            >
              Back to top<span className="bi bi-arrow-up ms-1"></span>
            </Link>
          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const InnerWrapper = styled.div`
  @media (max-width: 550px) {
    flex-direction: column;
  }
`;
const StyleP = styled.p`
  @media (max-width: 550px) {
    margin: 20px 0;
  }
`;
